import type { NavigateFunction } from 'react-router-dom'
import { useCreditsStore } from '@renderer/stores/creditsStore'

/** Project config snapshot (minimal shape) from config store. */
export function navigateAfterOutputsReady(
  navigate: NavigateFunction,
  projectId: string,
  config: {
    pages?: {
      result?: {
        settings?: {
          postSessionAi?: { enabled?: boolean } | null
          postSessionAiPaymentEnabled?: boolean
          postSessionAiPackages?: Array<{ isActive?: boolean }> | null
        } | null
      } | null
    } | null
  } | null
): void {
  const settings = config?.pages?.result?.settings
  const enabled = settings?.postSessionAi?.enabled === true
  if (!enabled) {
    navigate(`/${projectId}/result`)
    return
  }

  // Hybrid charging model (mirrors the server in /api/ai/post-session):
  //  - PAID config (AI-effect payment on + at least one active package): the guest pays
  //    per package, so the effect is always offered regardless of owner credits.
  //  - FREE config: the effect is funded by the owner's AI credits. With no usable credits
  //    the booth would only error on "Apply", so skip the dead-end step and go to Result.
  const guestPays =
    settings?.postSessionAiPaymentEnabled === true &&
    Array.isArray(settings?.postSessionAiPackages) &&
    settings.postSessionAiPackages.some((p) => p && p.isActive !== false)

  if (!guestPays) {
    // Same "has funding" semantic the booth uses elsewhere (checkCredits):
    // a numeric balance must be > 0; "Unlimited" (valid subscription) always passes.
    const { credits } = useCreditsStore.getState()
    const hasFunding = typeof credits === 'number' ? credits > 0 : true
    if (!hasFunding) {
      navigate(`/${projectId}/result`)
      return
    }
  }

  navigate(`/${projectId}/post-session-ai`)
}
